import { useEffect } from "react";
import { setActivePaginationLimit, setActivePaginationPage } from "@global-state/pages/admin/customerHistory/slice";
import { useGetUserPurchaseHistoryQuery } from "@RTKQuery/admin/customers/customers";
import { Pagination, Select } from "@ui";
import { useParams } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "store/hooks";

export function PaginationContainer() {
    const { id } = useParams();

    const { activePaginationLimit, activePaginationPage } = useAppSelector(state => state.customerHistoryAdminPage);

    const { currentData: data } = useGetUserPurchaseHistoryQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        user_id: Number(id)
    });

    const dispatch = useAppDispatch();
    const count = data?.count_items;

    useEffect(() => {
        if (count !== undefined && activePaginationPage > Math.max(1, Math.ceil(count / activePaginationLimit))) {
            dispatch(setActivePaginationPage(1));
        }
    }, [count, activePaginationPage, activePaginationLimit, dispatch]);

    if (data?.count_items) {
        return (
            <div className="grid grid-cols-3 items-center justify-items-center mx-[40px] mb-[20px] max-sm:grid-cols-1 max-sm:gap-[20px]">
                <div></div>
                <Pagination
                    activePage={activePaginationPage - 1}
                    count={Math.ceil((data?.count_items || 0) / activePaginationLimit)}
                    onClickPage={(page) => {
                        dispatch(setActivePaginationPage(page + 1))
                    }}
                />
                <div className="justify-self-end max-sm:justify-self-center">
                    <Select
                        listAlign="top"
                        currentValue={{
                            label: String(activePaginationLimit),
                            value: String(activePaginationLimit)
                        }}
                        onChange={(value) => {
                            dispatch(setActivePaginationLimit(Number(value.value)))
                        }}
                        listValues={[
                            {
                                label: "50",
                                value: "50"
                            },
                            {
                                label: "100",
                                value: "100"
                            },
                            {
                                label: "150",
                                value: "150"
                            },
                            {
                                label: "200",
                                value: "200"
                            }
                        ]}
                    />
                </div>
            </div>
        )
    } else {
        return null;
    }
}